import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faQuestionCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import CustomButton from '../CustomButton';

import { check, question } from '../../Assets/images';

import './style.css'
import { useNavigate } from 'react-router';

const CustomModal = (props) => {
    const navigate = useNavigate();
    const { show, close, size, success, heading, btnTxt, children, action, handleSubmit, login } = props;

    return (
        <>
            <Modal show={show} centered onHide={close} size={size} className="customModal" scrollable>
                <Modal.Header className="custom-modal-header border-0 pb-0">
                    <button className='closeButton ms-auto' onClick={close}><FontAwesomeIcon icon={faTimes} /></button>
                </Modal.Header>
                <Modal.Body className='text-center pt-0'>
                    {success && (
                        <div className="modalIconWrapper">
                            <FontAwesomeIcon icon={faCheckCircle} className='checkMark' />
                        </div>
                    )}
                    {!success && !children && !login && (
                        <FontAwesomeIcon icon={faQuestionCircle} className='questionMark' />
                    )}

                    <div className="modalContent">
                        <h2 className="modalHeading">{heading}</h2>

                        {children && !success ? (
                            <form onSubmit={handleSubmit} className='formDataStyle'>
                                {children}
                            </form>
                        ) : children ? (
                            <div className="modalChildren">
                                {children}
                            </div>
                        ) : null}

                        {!children && (
                            <>
                                {!login ? (
                                    success ? (
                                        <CustomButton onClick={close} variant='primaryButton' text={btnTxt ? btnTxt : 'Ok'} />
                                    ) : (
                                        <>
                                            <CustomButton onClick={action} variant='primaryButton' text="Yes" className="me-2" />
                                            <CustomButton onClick={close} variant='secondaryButton' text="No" />
                                        </>
                                    )
                                ) : (
                                    <>
                                        <CustomButton onClick={() => { navigate('/login') }} variant='primaryButton' text="Login" className="me-2" />
                                        <CustomButton onClick={() => { navigate('/sign-up') }} variant='secondaryButton' text="Signup" />
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CustomModal